<p-dialog
  [(visible)]="showConfirmationDialog"
  [modal]="true"
  [style]="{ width: '600px' }"
  [header]="'Confirmation'"
  (onHide)="hideDialog()"
>
  <div class="loadingMessage text-center p-3" *ngIf="loading">
    <i class="fa fa-2x fa-spin fa-spinner"></i>
  </div>

  <div style="margin-bottom: 10px" *ngIf="!loading">
    <h1>Route {{ isVME ? 'Deployed' : 'Grabbed' }}</h1>
    <p>You can now find this job in the 'My Jobs' page.</p>
    <p>
      Starting
      <span style="font-weight: bold">{{
        job?.pickupEarliest | datex : 'ddd Do MMM yy HH:mm '
      }}</span>
    </p>
    <p style="font-weight: bold; font-size: 1.2rem">
      Price {{ job?.price | currency : 'GBP' : 'symbol' }}
    </p>
    <p>Job number {{ job?.jobNumber }}</p>

    <div class="border-1 border-gray-300 p-2" style="border-radius: 10px">
      <p>Summary of {{ job?.tasks?.length }} Task(s)</p>

      <div *ngFor="let task of job?.tasks" class="task-row">
        <vehicle-reg>{{ task.vehicleReg }}</vehicle-reg>

        <div class="task-grid">
          <div class="pickup">
            <!-- if pickupEarliest & pickupLatest are the same day, only show time for pickup latest -->
            <ng-container
              *ngIf="isSameDay(task.pickupEarliest, task.pickupLatest); else pickupDiffDate"
            >
              {{ task.pickupEarliest | datex : 'ddd Do MMM HH:mm' }}
              –
              {{ task.pickupLatest | datex : 'HH:mm' }}
            </ng-container>
            <!-- otherwise show full day+date on both -->
            <ng-template #pickupDiffDate>
              {{ task.pickupEarliest | datex : 'ddd Do MMM HH:mm' }}
              –
              {{ task.pickupLatest | datex : 'ddd Do MMM HH:mm' }}
            </ng-template>
          </div>

          <div class="arrow">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </div>

          <div class="dropoff">
            <!-- dropoffEarliest: compare to pickupLatest -->
            <ng-container
              *ngIf="isSameDay(task.pickupLatest, task.dropoffEarliest); else dropEarliestNewDay"
            >
              {{ task.dropoffEarliest | datex : 'HH:mm' }}
            </ng-container>
            <ng-template #dropEarliestNewDay>
              {{ task.dropoffEarliest | datex : 'ddd Do MMM HH:mm' }}
            </ng-template>
            –
            <!-- dropoffLatest: compare to dropoffEarliest -->
            <ng-container
              *ngIf="isSameDay(task.dropoffEarliest, task.dropoffLatest); else dropLatestNewDay"
            >
              {{ task.dropoffLatest | datex : 'HH:mm' }}
            </ng-container>
            <ng-template #dropLatestNewDay>
              {{ task.dropoffLatest | datex : 'ddd Do MMM HH:mm' }}
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <button
      pButton
      label="Back to Search"
      class="ui-button-secondary"
      (click)="backToSearch()"
    ></button>
    <button
      pButton
      label="View Job"
      class="ui-button-primary"
      (click)="viewJob()"
      [disabled]="loading"
    ></button>
  </p-footer>
</p-dialog>
